import axiosInstance from '../axiosInterceptor/axiosInstance'

const base = 'v1/admin/default-overlays'

// Only send what the caller actually set: the backend treats a missing variant/targetMode as
// "resolve it for me", so sending nulls would pin values the caller never chose. Sport is the
// exception — it is required, and every caller passes it. statsMode is optional on the backend
// and falls back to Full, but every caller passes it explicitly.
const query = (obj) => {
  const params = {}
  for (const [k, v] of Object.entries(obj)) if (v !== undefined && v !== null) params[k] = v
  return Object.keys(params).length > 0 ? { params } : undefined
}

export const listDefaultOverlays = (config) =>
  axiosInstance.get(base, config).then((r) => r.data)

export const getDefaultOverlay = (slug, variant, sport, statsMode) =>
  axiosInstance.get(`${base}/${slug}`, query({ variant, sport, statsMode })).then((r) => r.data)

export const upsertDefaultOverlay = (slug, payload, variant, sport, statsMode) =>
  axiosInstance
    .put(`${base}/${slug}`, payload, query({ variant, sport, statsMode }))
    .then((r) => r.data)

export const getSampleValues = (slug, targetMode, sport, statsMode) =>
  axiosInstance
    .get(`${base}/${slug}/sample-values`, query({ targetMode, sport, statsMode }))
    .then((r) => r.data)

// Renders the placements being edited against sample values. Mirrors the season
// preview: a bundled default has no season, so it has its own admin route.
export const previewDefaultOverlay = (slug, body, sport, statsMode) =>
  axiosInstance
    .post(`${base}/${slug}/preview`, body, {
      ...query({ sport, statsMode }),
      responseType: 'text',
    })
    .then((r) => r.data)
